<template>
  <div class="container py-4">
    <h1>Termos de Uso</h1>
    <p class="lead">Ao usar a eDomi, você concorda com os termos abaixo. Leia atentamente.</p>
    <section class="mt-3">
      <h4>Uso do serviço</h4>
      <p>Os serviços oferecidos têm finalidade de divulgação e intermediação de imóveis. Sujeito a políticas internas.</p>
      <h4>Responsabilidade</h4>
      <p>Os anunciantes são responsáveis pelas informações dos imóveis. A eDomi fornece a plataforma.</p>
    </section>
  </div>
</template>

<script setup>
</script>

<style scoped>
.lead { color: #254163; }
</style>
